import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bulkInput", "emailList", "emailListContainer", "sendButton", "emailCount", "sendButtonText", "emailsField", "form"]
  static values = {
    emails: Array
  }

  connect() {
    this.emailsValue = []
  }

  handleBulkAdd(event) {
    event.preventDefault()
    const newEmails = this.bulkInputTarget.value
      .split(/[\s,]+/)
      .map(email => email.trim())
      .filter(email => this.isValidEmail(email) && !this.emailsValue.includes(email))
    
    if (newEmails.length > 0) {
      this.emailsValue = [...new Set([...this.emailsValue, ...newEmails])]
      this.bulkInputTarget.value = ''
      this.updateUI()
    }
  }

  isValidEmail(email) {
    // RFC 5322 compliant email regex
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    return emailRegex.test(email)
  }

  removeEmail(event) {
    const email = event.currentTarget.dataset.email
    this.emailsValue = this.emailsValue.filter(e => e !== email)
    this.updateUI()
  }

  updateUI() {
    this.emailCountTarget.textContent = `${this.emailsValue.length} email${this.emailsValue.length !== 1 ? 's' : ''}`
    const hasEmails = this.emailsValue.length > 0
    this.sendButtonTarget.disabled = !hasEmails
    this.sendButtonTarget.dataset.enabled = hasEmails
    this.sendButtonTextTarget.textContent = `Send ${this.emailsValue.length} Invitation${this.emailsValue.length !== 1 ? 's' : ''}`
    this.emailsFieldTarget.value = this.emailsValue.join(',')
    
    if (this.emailsValue.length === 0) {
      this.emailListTarget.classList.add('hidden')
    } else {
      this.emailListTarget.classList.remove('hidden')
      this.renderEmailList()
    }
  }

  renderEmailList() {
    this.emailListContainerTarget.innerHTML = this.emailsValue.map(email => `
      <div class="flex items-center justify-between bg-zinc-800/50 px-4 py-2 rounded-lg border border-zinc-700/30">
        <span class="text-zinc-300">${email}</span>
        <button data-action="invite-form#removeEmail" data-email="${email}" class="text-zinc-500 hover:text-zinc-300 transition-colors">
          <i data-lucide="x" class="w-4 h-4"></i>
        </button>
      </div>
    `).join('')
  }
} 